/* Somnia | barra fija de compra en móvil (cambio 17); markup en snippets/somnia-sticky-atc.liquid.
   El botón es type="submit" del form nativo (validación de talla + AJAX del tema; sin fetch propio).
   La talla se marca con los radios nativos (section.somniaSize, de somnia-product.js).
   Hoja de tallas con theme.Drawers (foco atrapado, Escape, foco de regreso). */
(function () {
  'use strict';

  var bar = document.querySelector('[data-somnia-sticky]');
  if (!bar) return;
  var sheetEl = bar.dataset.sheetId ? document.getElementById(bar.dataset.sheetId) : null;
  var sheet = null;

  /* "Calcula tu talla" en la hoja: cierra la hoja antes de abrir la guía (corre antes que theme.Drawers) */
  var calc = sheetEl && sheetEl.querySelector('[data-somnia-sheet-calc]');
  if (calc) calc.addEventListener('click', function () { if (sheet && sheet.isOpen) close(false); });

  function close(returnFocus) {
    if (!sheet) return;
    if (!returnFocus && sheet.activeSource) {
      sheet.activeSource.setAttribute('aria-expanded', 'false');
      sheet.activeSource = null;
    }
    sheet.close();
  }

  function init() {
    var section = bar.closest('[data-section-type="product"]');
    var form = document.getElementById(bar.dataset.formId);
    var nativeBtn = form && form.querySelector('[data-add-to-cart]');
    if (!section || !nativeBtn) return;
    var nativeText = nativeBtn.querySelector('[data-add-to-cart-text]');
    var atc = bar.querySelector('[data-somnia-sticky-atc]');
    var label = atc.querySelector('[data-somnia-sticky-label]');
    var priceEl = atc.querySelector('[data-somnia-sticky-price]');
    var sizeBtn = bar.querySelector('[data-somnia-sticky-size]');
    var sizeText = sizeBtn && sizeBtn.querySelector('[data-somnia-sticky-size-text]');
    var size = section.somniaSize || null;
    var prices = {};
    try { prices = JSON.parse(bar.querySelector('[data-somnia-sticky-prices]').textContent); } catch (err) {}
    var inst = null;
    (theme.sections.instances || []).forEach(function (i) { if (i.type === 'product' && i.container === section) inst = i; });
    var variant = inst && inst.variants ? inst.variants.currentVariant : null;
    if (sheetEl && theme.Drawers) sheet = new theme.Drawers(sheetEl.id, 'somnia-size-sheet');
    var title = sheetEl && sheetEl.querySelector('[data-somnia-sheet-title]');
    var mode = 'select';

    /* Espejo del botón nativo (disponible, Agotado, No disponible) + precio por variante */
    function update() {
      var r = size ? size.chosen() : null;
      if (sizeText) sizeText.textContent = r ? bar.dataset.textSize.replace('[size]', r.value) : bar.dataset.textChoose;
      atc.disabled = nativeBtn.disabled;
      label.textContent = nativeText ? nativeText.textContent.trim() : label.textContent;
      priceEl.textContent = !nativeBtn.disabled && variant && prices[variant.id] ? prices[variant.id] : '';
      priceEl.hidden = !priceEl.textContent;
    }
    section.addEventListener('variantChange', function (evt) { variant = evt.detail.variant; update(); });
    update();

    /* Doble toque = una sola pieza (además del candado del tema) */
    var busy = false, timer;
    function done() { busy = false; clearTimeout(timer); atc.classList.remove('btn--loading'); }
    function start() { busy = true; atc.classList.add('btn--loading'); timer = setTimeout(done, 8000); }
    form.addEventListener('ajaxProduct:added', done);
    form.addEventListener('ajaxProduct:error', done);

    function openSheet(m, evt) {
      if (!sheet) return;
      mode = m;
      if (title) title.textContent = m === 'add' ? bar.dataset.textTitleAdd : bar.dataset.textTitle;
      var r = size.chosen();
      var rec = size.rec();
      sheetEl.querySelectorAll('[data-somnia-sheet-size]').forEach(function (input) {
        input.checked = !!r && input.value === r.value;
        var badge = input.parentNode.querySelector('[data-somnia-sheet-rec]');
        if (badge) badge.hidden = !(rec && rec.size === input.value);
      });
      sheet.open(evt);
    }

    if (sizeBtn) sizeBtn.addEventListener('click', function (evt) { openSheet('select', evt); });

    atc.addEventListener('click', function (evt) {
      if (busy) { evt.preventDefault(); return; }
      if (size && !size.chosen()) { evt.preventDefault(); openSheet('add', evt); return; }
      if (!atc.disabled) start();
    });

    if (sheetEl) {
      /* Volver a tocar la talla ya elegida (no dispara change): solo cierra la hoja */
      sheetEl.addEventListener('click', function (evt) {
        var input = evt.target, r = size.chosen();
        if (input.hasAttribute && input.hasAttribute('data-somnia-sheet-size') && mode === 'select' && r && r.value === input.value) close(true);
      });
      sheetEl.addEventListener('change', function (evt) {
        var input = evt.target;
        if (!input.hasAttribute('data-somnia-sheet-size')) return;
        var add = mode === 'add' && !input.hasAttribute('data-sold-out');
        size.select(input.value);
        close(!add);
        if (add && !busy && !nativeBtn.disabled) { start(); nativeBtn.click(); }
      });
    }

    /* Visible solo después de pasar el botón nativo (ya quedó arriba de la pantalla). Si el botón aún no
       llega a la pantalla, la barra no aparece: en móvil ya cabe en la primera pantalla. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(nativeBtn);
    }
  }

  if (window.theme && theme.sections) init();
  else document.addEventListener('page:loaded', init, { once: true });
})();
